export const COLOR_DANGER = "#dc3545";
export const COLOR_PRIMARY = "#41909a";
